import { AppLoader } from '@bbl-digital/snorre'
import styled from '@emotion/styled'
import { css, keyframes } from '@emotion/react'

const fadeIn = keyframes`
  from { 
    opacity: 0;
  }
  to { 
    opacity: 1;
  }
`

const LoaderWrapper = styled.div<{ $overlay?: boolean }>`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ $overlay }) =>
    $overlay &&
    css`
      position: fixed;
      z-index: 11;
      width: 100vw;
      z-index: 1000;
      background-color: rgba(189, 189, 189, 0.3);
      animation: ${fadeIn} 50ms ease;
    `}
`

type Props = {
  overlay?: boolean
}

const PageLoader = ({ overlay }: Props) => (
  <LoaderWrapper $overlay={overlay}>
    <AppLoader />
  </LoaderWrapper>
)

export default PageLoader
